import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router";
import { useScrollEnter } from "../../hooks/useScrollEnter";
import { BrandLink } from "../BrandLink";
import { footerColumns, footerContact, footerLegal, footerSocial, type FooterNavLink } from "./site-footer-data";
import "./site-footer.css";

function FooterLink({ item }: { item: FooterNavLink }) {
  if (item.href) return <a href={item.href}>{item.label}</a>;
  if (item.to) return <Link to={item.to}>{item.label}</Link>;
  return <span>{item.label}</span>;
}

/** 站点页脚：收尾行动区 + 链接与联系方式 + 横跨整屏的品牌字标。 */
export function SiteFooter() {
  const ref = useScrollEnter<HTMLElement>(0.1);

  return (
    <footer ref={ref} className="site-footer">
      <div className="site-footer-inner">
        <section className="site-footer-cta" aria-labelledby="site-footer-title">
          <h2 id="site-footer-title">
            <span>下一张情绪板，</span>
            <span>由你来搭</span>
          </h2>
          <div className="site-footer-actions">
            <Link className="site-footer-start" to="/moodboard">
              开始创作
              <i aria-hidden="true"><ArrowRight size={18} strokeWidth={1.8} /></i>
            </Link>
            <Link className="site-footer-text-link" to="/community">先逛逛社区 <ArrowUpRight size={16} /></Link>
          </div>
        </section>

        <div className="site-footer-grid">
          <div className="site-footer-brand">
            <BrandLink />
            <p>为材料、空间与产品建立可持续生长的灵感档案。</p>
            <div className="site-footer-contact" aria-label={footerContact.title}>
              <a href={footerContact.phoneHref}><small>{footerContact.phoneLabel}</small>{footerContact.phone}</a>
              <a href={`mailto:${footerContact.email}`}><small>{footerContact.emailLabel}</small>{footerContact.email}</a>
            </div>
          </div>
          {footerColumns.map((column) => (
            <nav className="site-footer-col" key={column.title} aria-label={column.title}>
              <h3>{column.title}</h3>
              {column.links.map((item) => <FooterLink item={item} key={item.label} />)}
            </nav>
          ))}
          <div className="site-footer-social">
            <h3>关注我们</h3>
            <div>
              {footerSocial.map((item) => (
                <figure key={item.id}>
                  <img src={item.src} alt={item.alt} width={96} height={96} loading="lazy" decoding="async" />
                  <figcaption>{item.label}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        <div className="site-footer-legal">
          <small>{footerLegal.copyright}</small>
          <a href={footerLegal.icpHref} target="_blank" rel="noreferrer">{footerLegal.icp}</a>
        </div>

        {/* 字标放在最后，压在页脚底边被裁掉一截，不遮挡任何内容。 */}
        <p className="site-footer-wordmark" aria-hidden="true">MoodShow</p>
      </div>
    </footer>
  );
}
